import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const PluginsPrimengPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{sky.50}',
      100: '{sky.100}',
      200: '{sky.200}',
      300: '{sky.300}',
      400: '{sky.400}',
      500: '{sky.500}',
      600: '{sky.600}',
      700: '{sky.700}',
      800: '{sky.800}',
      900: '{sky.900}',
      950: '{sky.950}',
    },
  },
});

export const providePluginsPrimeNG = () =>
  providePrimeNG({
    theme: {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      preset: PluginsPrimengPreset,
      options: {
        darkModeSelector: false,
        // Remove default 'p' prefix because primeflex classes don't use prefix (ie border-200 --> border-color: var(--surface-200))
        prefix: '',
      },
    },
  });
